import React from "react";
import Layout from "./layout";
import Hero from "./hero";
import SEO from "./seo";
import Container from "./container";
import "./helpPage.css";

const HelpPage = ({ name, children, metaTitle, metaDescription, keywords }) => {
  return (
    <Layout>
      <SEO
        title={metaTitle}
        description={metaDescription}
        keywords={keywords}
      />
      <Hero
        maxHeight="200px"
        justifyContent="center"
        style={{
          background: "#62abd3"
        }}
      >
        <h1>Pomoc</h1>
        <p>{name}</p>
      </Hero>
      <Container className="helpPageContainer">{children}</Container>
    </Layout>
  );
};

export default HelpPage;
